import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { PaginatedResultModel, PaginationSearchModel } from '@data-layer/models/common';
import {
  ManagementContainerModel,
  ManagementContainerSearchModel,
  ManagementMasterBillModel,
  ManagementUpdateContainerModel,
  ManagementVoyageModel,
} from '@data-layer/models/management';

@Injectable({
  providedIn: 'root',
})
export class ContainersRepository {
  constructor(private apiService: ApiService) {}

  public search(
    params?: ManagementContainerSearchModel,
    isShowLoader?: boolean,
  ): Observable<PaginatedResultModel<ManagementContainerModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementContainerModel>>(
      environment.url.freight.containersManagement,
      { params },
      { isShowLoader },
    );
  }

  public searchByVoyageId(
    voyageId: ManagementVoyageModel['id'],
    params: PaginationSearchModel,
    isShowLoader?: boolean,
  ): Observable<PaginatedResultModel<ManagementContainerModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementContainerModel>>(
      `${environment.url.freight.voyagesManagement}/${voyageId}/containers`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public create(
    voyageId: ManagementVoyageModel['id'],
    model: ManagementUpdateContainerModel,
    isShowLoader?: boolean,
  ): Observable<ManagementContainerModel> {
    return this.apiService.post<ManagementContainerModel>(
      `${environment.url.freight.voyagesManagement}/${voyageId}/containers`,
      model,
      null,
      {
        isShowLoader,
      },
    );
  }

  public get(id: ManagementContainerModel['id'], isShowLoader?: boolean): Observable<ManagementContainerModel> {
    return this.apiService.get<ManagementContainerModel>(`${environment.url.freight.containersManagement}/${id}`, null, { isShowLoader });
  }

  public update(
    id: ManagementContainerModel['id'],
    model: ManagementUpdateContainerModel,
    isShowLoader?: boolean,
  ): Observable<ManagementContainerModel> {
    return this.apiService.put<ManagementContainerModel>(`${environment.url.freight.containersManagement}/${id}`, model, null, {
      isShowLoader,
    });
  }

  public delete(id: ManagementContainerModel['id'], isShowLoader?: boolean): Observable<never> {
    return this.apiService.delete(`${environment.url.freight.containersManagement}/${id}`, null, { isShowLoader });
  }

  public attachToMasterBill(
    id: ManagementContainerModel['id'],
    masterBillId: ManagementMasterBillModel['id'],
    isShowLoader?: boolean,
  ): Observable<never> {
    return this.apiService.put(`${environment.url.freight.containersManagement}/${id}/master-bill`, masterBillId, null, { isShowLoader });
  }

  public deAttachMasterBill(id: ManagementContainerModel['id'], isShowLoader?: boolean): Observable<never> {
    return this.apiService.delete(`${environment.url.freight.containersManagement}/${id}/master-bill`, null, { isShowLoader });
  }
}
